export default "__VITE_ASSET__C0W8tyLD__"